import {store} from './store';
import {Module, VuexModule, Mutation, Action} from 'vuex-module-decorators';

interface iListIdName{
    listid:number,
    list_name:string
}

@Module({ namespaced: true, dynamic: true, store, name: 'storeWorkingSpace'})
export default class storeWorkingSpace extends VuexModule {
    listid:number=0;
    list_name:string='';

    @Mutation
    SET_CURRENT_WORK_A_LIST(plistparam:iListIdName){
        this.listid=plistparam.listid;
        this.list_name=plistparam.list_name;
    }
    @Action
    set_current_work_a_list(plistparam:iListIdName){
        this.context.commit('SET_CURRENT_WORK_A_LIST',plistparam);
    }

}
